import { Component, inject, signal } from '@angular/core';
import { FileItemModel } from '@models/module/fields/main';
import { FolderTreeComponent } from '@module-definition/folder-tree/folder-tree.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { UserStore } from '@signal-store';

@Component({
  selector: 'cipo-demo-files-tree',
  imports: [FolderTreeComponent, FlexLayoutModule],
  templateUrl: './demo-files-tree.component.html',
})
export class DemoFilesTreeComponent {
  userStore = inject(UserStore);

  selectedNode = signal<FileItemModel>(null);
  onNodeClick(node: FileItemModel) {
    this.selectedNode.set(node);
  }
}
